import {Button, Popover, Row, Col, Spin} from 'antd';

export const SavePurchaseOrderWidget = ({spin, purchaseOrder, buyer, dueDate, products, onSave, props}) => {
    const onClick = () => {
        if (onSave) {
            onSave();
        }
    }

    const buyerIsEmpty = (buyer === undefined) || (buyer === null);
    const dueDateIsEmpty = (dueDate === undefined) || (dueDate === null);
    const productIsEmpty = (products === undefined) || (products === null) || (products.length <= 0);
    const disabled = (buyerIsEmpty || dueDateIsEmpty || productIsEmpty);

    const buttonLabel = (purchaseOrder === undefined) ? "Create P.O." : "Save"

    let infoLabel = ""
    if ((buyerIsEmpty) && (dueDateIsEmpty)) {
        infoLabel = 'Select Buyer and Due Date'
    } else if (buyerIsEmpty) {
        infoLabel = 'Select Buyer'
    } else if (dueDateIsEmpty) {
        infoLabel = 'Select Due Date'
    }

    if (productIsEmpty) {
        infoLabel += ".  Add at least one P.O. item"
    }

    let popOverContent;
    if ((purchaseOrder === undefined) || (purchaseOrder === null)) {
        popOverContent = 'Create the Purchase Order'
    } else {
        popOverContent = 'Save Changes'
    }

    const purchaseOrderContent = (purchaseOrder !== undefined) &&
        <div>
            <Row>
                Purchase Order: {purchaseOrder.id}
            </Row>
            <Row>
                PO Number: {purchaseOrder.poNumber}
            </Row>
        </div>

    if (spin === true) {
        return <Spin />
    }

    return <>
        {purchaseOrderContent}
        <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={3}><Popover placement={'right'} content={popOverContent}><Button onClick={onClick} disabled={disabled}>{buttonLabel}</Button></Popover></Col>
            <Col><div style={{color: 'red', paddingTop: '5px'}}>{infoLabel}</div></Col>
        </Row>
    </>
}